import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import NotificationBar from '@boschebike/ebds-react/dist-esm/components/NotificationBar.js';
import { useMounted } from '../../react/hooks/useMounted.js';

/**
 * @typedef {import('../../App.d.ts').NotificationBarProps} NotificationBarProps
 */
/**
 * @param {NotificationBarProps} props
 */
export default (props) => {
  const mounted = useMounted();
  if (!mounted) {
    return null;
  }

  return (
    <Container>
      <NotificationBar
        data-testid="notification-bar"
        icon={props.icon}
        type={props.type}
        appearance={props.appearance}
      >
        <p dangerouslySetInnerHTML={{ __html: String(props.text) }} />
      </NotificationBar>
    </Container>
  );
};
